import React from 'react';
import { Alert, Box, Chip, Stack, Typography } from '@mui/material';

type Props = {
  title: string;
  subtitle?: string;
  status?: 'ready' | 'blocked' | 'warning' | 'complete';
  message?: string;
};

class FWizardStepHeader extends React.PureComponent<Props> {
  chipColor(): any {
    if (this.props.status === 'complete') return 'success';
    if (this.props.status === 'blocked') return 'error';
    if (this.props.status === 'warning') return 'warning';
    return 'primary';
  }

  render() {
    return (
      <Stack spacing={1.5}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 800 }}>{this.props.title}</Typography>
            {this.props.subtitle && <Typography variant="body2" color="text.secondary">{this.props.subtitle}</Typography>}
          </Box>
          {this.props.status && <Chip size="small" label={this.props.status.toUpperCase()} color={this.chipColor()} />}
        </Stack>

        {this.props.message && (
          <Alert severity={this.props.status === 'blocked' ? 'error' : this.props.status === 'warning' ? 'warning' : 'info'}>
            {this.props.message}
          </Alert>
        )}
      </Stack>
    );
  }
}

export default FWizardStepHeader;
